import { ListPathQuestionSchemaType } from '../generated/types.js';

/**
 * Is the submit button hidden on the current node for any given reason
 */

function isSubmitButtonHidden(questionViewModel) {
  /**
   * If there are multiple questions on the node we always show the submit button
   */
  if (questionViewModel.questions.length > 1) {
    return false;
  }

  var questionReference = questionViewModel.questions[0];
  /**
   * In the event that the question is optional, we always show the submit button since it offers them
   * the chance to move foward without selecting an option
   */

  if (!questionReference.commonFields.required) {
    return false;
  }
  /**
   * Is the only question a single select list questions and have they not been answered already since
   * we could be moving backward in a path
   */


  if (questionReference.__typename === 'ListQuestionPathNodeFlowViewModel') {
    var isSingleSelect = questionReference.listSchemaType === ListPathQuestionSchemaType.SINGLE_SELECT_LIST; // Make sure it hasn't been answered, we may be moving backward

    var hasBeenAnswered = questionReference.choices.find(function (choice) {
      return choice.selected;
    });
    return isSingleSelect && !hasBeenAnswered;
  }

  return false;
}

export default isSubmitButtonHidden;
//# sourceMappingURL=isSubmitButtonHidden.js.map
